import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system"

const baseStyle = defineStyle({
  fontSize: 12,
})

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/tooltip.ts}
 */
export const Tooltip = defineStyleConfig({
  baseStyle,
})
